import React from "react";
import { FileCheck2, ShieldCheck } from "lucide-react";

/**
 * HeroPreviewCard — mockup visual del Diagnóstico que aparece a la derecha del hero.
 */
export function HeroPreviewCard() {
  return (
    <div className="relative">
      {/* Floating accent: semáforo top */}
      <div className="absolute -top-3 -left-3 bg-white border border-brand-burgundy/20 rounded-sm px-3 py-2 shadow-md z-10 flex items-center gap-2">
        <span className="h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true" />
        <span className="h-2.5 w-2.5 rounded-full bg-amber-400" aria-hidden="true" />
        <span className="h-2.5 w-2.5 rounded-full bg-red-500" aria-hidden="true" />
        <span className="text-[10px] uppercase tracking-widest text-gray-600 font-semibold ml-1">Semáforo</span>
      </div>

      {/* Card principal */}
      <div className="bg-white border border-gray-200 rounded-sm shadow-xl overflow-hidden">
        {/* Header */}
        <div className="bg-brand-burgundy text-white px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <FileCheck2 className="h-4 w-4" aria-hidden="true" />
            <span className="text-xs font-semibold uppercase tracking-widest">Diagnóstico Precontractual</span>
          </div>
          <span className="text-[9px] uppercase tracking-widest bg-emerald-500 text-white px-2 py-0.5 rounded-sm font-semibold">
            Aprobado
          </span>
        </div>

        {/* Body */}
        <div className="p-5 space-y-4">
          <div>
            <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-1">Caso</p>
            <p className="font-serif text-sm text-gray-900 leading-tight">
              Adquisición de elementos de oficina · Selección abreviada
            </p>
          </div>

          {/* Hallazgos */}
          <div>
            <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-2">Hallazgos</p>
            <ul className="space-y-1.5">
              <li className="flex items-start gap-2 text-xs text-gray-800">
                <span className="h-2 w-2 rounded-full bg-emerald-500 mt-1.5 shrink-0" aria-hidden="true" />
                <span>Modalidad coherente con valor estimado.</span>
              </li>
              <li className="flex items-start gap-2 text-xs text-gray-800">
                <span className="h-2 w-2 rounded-full bg-amber-400 mt-1.5 shrink-0" aria-hidden="true" />
                <span>Análisis del sector requiere fuente verificable.</span>
              </li>
              <li className="flex items-start gap-2 text-xs text-gray-800">
                <span className="h-2 w-2 rounded-full bg-red-500 mt-1.5 shrink-0" aria-hidden="true" />
                <span>Falta soporte de pluralidad de oferentes.</span>
              </li>
            </ul>
          </div>

          {/* Norma aplicable */}
          <div className="bg-brand-cream-soft border border-gray-200 px-3 py-2 rounded-sm">
            <p className="text-[10px] uppercase tracking-widest text-brand-burgundy font-semibold mb-1">
              Norma aplicable
            </p>
            <p className="text-xs text-gray-800">Ley 1150 de 2007 · Art. 2 numeral 2 lit. h</p>
          </div>

          {/* Revisión humana */}
          <div className="flex items-center gap-2 pt-2 border-t border-gray-100">
            <ShieldCheck className="h-4 w-4 text-brand-burgundy" aria-hidden="true" />
            <span className="text-[10px] text-gray-600">
              Revisado por <strong className="text-gray-900">Equipo Experto JustSapiens</strong>
            </span>
          </div>
        </div>
      </div>

      {/* Accent corner ribbon */}
      <div className="absolute -bottom-3 -right-3 bg-brand-coral text-white text-[10px] uppercase tracking-widest px-3 py-2 rounded-sm shadow-md font-semibold">
        Insumo de apoyo
      </div>
    </div>
  );
}
